import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './LayoutTwoColumn.module.css';

const LayoutTwoColumn = ({ leftColumn, rightColumn, className, rootClassName }) => {
    const classes = classNames(rootClassName || css.root, className);

    return (
        <div className={classes}>
            <div className={css.leftColumn}>
                {leftColumn}
            </div>
            <div className={css.rightColumn}>
                {rightColumn}
            </div>
        </div>
    );
};

LayoutTwoColumn.propTypes = {
    leftColumn: PropTypes.node.isRequired,
    rightColumn: PropTypes.node.isRequired,
    className: PropTypes.string,
    rootClassName: PropTypes.string,
};

export default LayoutTwoColumn;
